import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Save } from "lucide-react";
import AsyncButton from "@/components/AsyncButton";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";

interface ProjectManagersAddUsersSubmitButtonProps {
  onSubmit: () => void;
  isSubmitting: boolean;
}

const ProjectManagersAddUsersSubmitButtonComponent = ({
  onSubmit,
  isSubmitting,
}: ProjectManagersAddUsersSubmitButtonProps) => {
  const { t } = useTranslation();
  const selectedCount = useRowSelectionCount();

  return (
    <AsyncButton
      onClick={onSubmit}
      loading={isSubmitting}
      disabled={selectedCount === 0}
      label={t("projects.managers.addUsers.submit")}
      loadingLabel={t("commonEditor.toolbar.saving")}
      icon={<Save className="mr-2 h-5 w-5" />}
    />
  );
};

export const ProjectManagersAddUsersSubmitButton = memo(
  ProjectManagersAddUsersSubmitButtonComponent,
);
